<template>
  <div id="app">
    <Header></Header>
    <CookieBox></CookieBox>

    <router-view/>
    <Footer></Footer>
  </div>
</template>

<script>
import Header from "@/components/global/Header";
import Footer from "@/components/global/Footer";
import CookieBox from "@/components/global/Footer/CookieBox";

export default {
  name: 'App',
  components: {
    CookieBox,
    Header,
    Footer
  },
};
</script>

<style lang="scss">
  @import 'style/main.scss';
</style>



// WEBPACK FOOTER //
// src/App.vue